import { flattenNestedSvg } from '@/utils'

export const DefaultFrame = ({
	patternMarkup,
	backgroundColor,
	enablePadding = true,
}: {
	patternMarkup: string
	backgroundColor: string
	enablePadding?: boolean
}) => {
	return (
		<svg viewBox="0 0 170 170" xmlns="http://www.w3.org/2000/svg">
			<rect width={170} height={170} fill={backgroundColor} />
			<g
				dangerouslySetInnerHTML={{
					__html: enablePadding
						? flattenNestedSvg(patternMarkup, {
								x: 8,
								y: 8,
								width: 154,
								height: 154,
							})
						: flattenNestedSvg(patternMarkup, {
								x: 0,
								y: 0,
								width: 170,
								height: 170,
							}),
				}}
			/>
		</svg>
	)
}
